import React, { useState, useEffect } from 'react';

function LangButton() {
  // localStorage에서 언어 가져오기 (없으면 기본 'en')
  const [language, setLanguage] = useState(localStorage.getItem('preferredLang') || 'en');

  useEffect(() => {
    localStorage.setItem('preferredLang', language);
  }, [language]);

  // 버튼 클릭 시 'ko' ↔ 'en' 토글 후 새로고침
  const toggleLanguage = () => {
    const newLanguage = language === 'ko' ? 'en' : 'ko';
    localStorage.setItem('preferredLang', newLanguage);
    setLanguage(newLanguage);
    window.location.reload(); // 페이지 새로고침
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex font-semibold f-16 mt-auto mb-[6rem] text-right mx-10"
    >
      한국어 / English
    </button>
  );
}

export default LangButton;
